import { render, staticRenderFns } from "./CITab.vue?vue&type=template&id=74f47954&scoped=true"
import script from "./CITab.vue?vue&type=script&lang=js"
export * from "./CITab.vue?vue&type=script&lang=js"
import style0 from "./CITab.vue?vue&type=style&index=0&id=74f47954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f47954",
  null
  
)

export default component.exports